import { ExpandMore } from "@mui/icons-material";
import clsx from "clsx";
import { FC, ReactNode } from "react";

export interface IRichLogsCollapsibleFilterPanelProps {
  emoji: string;
  title: string;
  collapsed: boolean;
  onToggle: () => void;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  expandLabel?: string;
  collapseLabel?: string;
}

export const RichLogsCollapsibleFilterPanel: FC<
  IRichLogsCollapsibleFilterPanelProps
> = ({
  emoji,
  title,
  collapsed,
  onToggle,
  children,
  className,
  contentClassName,
  expandLabel = "Show filters",
  collapseLabel = "Hide filters",
}) => {
  return (
    <div
      className={clsx("log__collapsible-filter-section", className, {
        collapsed,
      })}
    >
      <button
        type="button"
        className="log__collapsible-filter-section__toggle"
        onClick={onToggle}
        aria-expanded={!collapsed}
        title={collapsed ? expandLabel : collapseLabel}
      >
        <span className="log__collapsible-filter-section__emoji" aria-hidden>
          {emoji}
        </span>
        <span className="log__collapsible-filter-section__title">{title}</span>
        <ExpandMore
          className={clsx("log__collapsible-filter-section__arrow", {
            expanded: !collapsed,
          })}
          fontSize="small"
        />
      </button>
      <div
        className={clsx(
          "log__collapsible-filter-section__content",
          contentClassName,
          {
            collapsed,
          },
        )}
      >
        {children}
      </div>
    </div>
  );
};
